import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const CellCSSContainer = styled.div<{ $hasActions: boolean }>`
  display: table-cell;
  box-sizing: border-box;
  overflow: ${({ $hasActions }) => ($hasActions ? 'visible' : 'hidden')};
  margin: 0;
  max-width: 100%;
  padding: ${pxToRem(5)} ${pxToRem(8)};
  a {
    color: #333;
    &:hover {
      text-decoration: underline;
    }
  }
  .ui.checkbox {
    vertical-align: top;
  }
  .ui.dropdown {
    width: 100%;
  }
  .cssDisabled {
    color: #d6d6d6;
  }
  .cssEnabled {
    color: #2cc36b;
  }
  &:not([data-checkbox='true']) {
    min-width: ${pxToRem(20)};
  }
  &:not([data-docked='true']) {
    z-index: 0;
  }
  &[data-docked='true'] {
    z-index: 2;
    background: inherit;
  }
  [name] {
    width: 100%;
  }
  [name='Experiment setup'] {
    display: flex;
    align-items: center;
  }
  &.cssCellDropdown {
    z-index: auto !important;
    overflow: unset;
    .menu {
      margin-bottom: -${pxToRem(200)} !important;
    }
  }
  &.cssGroupCell {
    &:not(:first-child) {
      &:empty {
        border-top-color: transparent;
        border-bottom-color: transparent;
      }
      &:not(:empty) {
        border-top: ${pxToRem(1)} solid #eff0f0;
        border-bottom-color: transparent;
        margin-top: -1px;
        [data-role='row']:nth-child(2) > & {
          border-top: ${pxToRem(1)} solid transparent;
          margin-top: 0;
        }
      }
    }
    &:first-child {
      background: #eff0f0;
      &:not(:empty) {
        &,
        [data-role='row']:nth-child(2) > & {
          border-top: ${pxToRem(1)} solid #fff;
        }
      }
    }
    [data-appearance='iterable'] > [data-role='table'] & {
      &:first-child {
        background: #eff0f0;
        border-bottom-color: transparent;
        &:not(:empty) {
          &,
          [data-role='row']:nth-child(2) > & {
            border-top: ${pxToRem(1)} solid #fff;
          }
        }
      }
    }
  }
`;

export const CellWrapper = styled.div`
  display: flex;
`;
